import React, { useState, useEffect } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

/**
 * 
 * @param {{editClick:Function,deleteClick:Function,product:object, toggleShareModal:Function}} props
 */

const AllProductsItemDropdown = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isAdded, setIsAdded] = useState(false);
    const [product, setProduct] = useState(props.product)

    useEffect (() => {
        if (props.addedProduct != null && props.addedProduct != undefined && props.addedProduct.merchantProductId === product.merchantProductId) {
            const updatedProduct = product;
            updatedProduct.shareCode = props.addedProduct.shareCode;
            updatedProduct.userMerchantProductId = props.product.userMerchantProductId;
            setProduct(updatedProduct);
        }
    
    }, [props.addedProduct]);

    const handleAdd = async () => {
        setIsAdded(true);
        await props.addProductToInventory(product.merchantProductId);
    }

    const handleShare = async () => {
        if (props.showAdd && !isAdded) {
            setIsAdded(true);
            await props.addProductToInventory(product.merchantProductId, true);
        }

        props.toggleShareModal(product, props.isUserMerchant ? props.isUserMerchant : false);
    }

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
            <DropdownToggle caret>
                Action
            </DropdownToggle>

            <DropdownMenu>
                {props.showAdd && !isAdded ? 
                <DropdownItem onClick={handleAdd} className="p-1">
                    Add
                </DropdownItem>
                  :
                <DropdownItem disabled className="p-1">
                    Add
                </DropdownItem>}
                <DropdownItem className="p-1" onClick={handleShare}>
                    Share
                </DropdownItem>
            </DropdownMenu>

        </Dropdown>

    )
}


export default AllProductsItemDropdown;